import type { Plugin } from "unified";
import { visit } from "unist-util-visit";

const UNDERLINE_REGEX = /\+\+([^+]+)\+\+/g;

export const rehypeUnderline: Plugin = () => {
    return (tree: any) => {
        visit(tree, "text", (node: any, index: number | undefined, parent: any) => {
            if (!parent || typeof node.value !== "string") return;

            const value = node.value;
            const parts: any[] = [];
            let lastIndex = 0;
            let match;

            while ((match = UNDERLINE_REGEX.exec(value)) !== null) {
                const [full, content] = match;
                const start = match.index;

                if (start > lastIndex) {
                    parts.push({ type: "text", value: value.slice(lastIndex, start) });
                }

                // Create div element with underline className
                parts.push({
                    type: "element",
                    tagName: "span",
                    properties: {
                        className: "underline",
                    },
                    children: [{ type: "text", value: content }],
                });

                lastIndex = start + full.length;
            }

            if (lastIndex < value.length) {
                parts.push({ type: "text", value: value.slice(lastIndex) });
            }

            if (parts.length > 0) {
                parent.children.splice(index!, 1, ...parts);
            }
        });
    };
};
